import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

const Barcode = ({ value, format }) => {
    const barcodeRef = useRef(null);

    useEffect(() => {
        if (barcodeRef.current) {
            JsBarcode(barcodeRef.current, value, {
                format: 'CODE128', // Use o formato padrão ou personalizado
                displayValue: true,
                width: 1,  // Largura padrão de 1
                height: 35,
                fontSize:14
            });
        }
    }, [value, format]);

    return <svg ref={barcodeRef}></svg>;
};

export default Barcode;
